import { render, staticRenderFns } from "./UserJudge.vue?vue&type=template&id=2a76f02c"
import script from "./UserJudge.vue?vue&type=script&lang=js"
export * from "./UserJudge.vue?vue&type=script&lang=js"
import style0 from "./UserJudge.vue?vue&type=style&index=0&id=2a76f02c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports